import { render, staticRenderFns } from "./investmentClues8.vue?vue&type=template&id=3b069ce1&"
import script from "./investmentClues8.vue?vue&type=script&lang=js&"
export * from "./investmentClues8.vue?vue&type=script&lang=js&"
import style0 from "./investmentClues8.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports